<template>
  <div class="app-container">
    <div class="title-row"><span class="title">{{ this.$route.meta.title }}</span></div>
    <el-form @submit.native.prevent :model="queryParams" ref="queryForm" size="small" :inline="true" v-show="showSearch" label-width="68px">
      <el-form-item label="标签名" prop="tagName">
        <el-input v-model="queryParams.tagName" placeholder="请输入标签名" clearable  @keyup.enter.native="handleQuery"/>
      </el-form-item>
      <el-form-item>
        <el-button type="primary"  icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
        <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form>
    <!-- 表格操作 -->
    <el-row :gutter="10" class="mb8">
      <el-col :span="1.5">
        <el-button v-hasPermi="['article:tag:add']" type="primary" plain size="mini" icon="el-icon-plus" @click="openModel(null)">新增</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button v-hasPermi="['article:tag:remove']" type="danger" plain size="mini" icon="el-icon-delete" :disabled="multiple" @click="handleDelete">批量删除</el-button>
      </el-col>
      <right-toolbar :showSearch.sync="showSearch" @queryTable="getList" ></right-toolbar>
    </el-row>
    <!-- 表格展示 -->
    <el-table :data="tagList" v-loading="loading" @selection-change="selectionChange" >
      <!-- 表格列 -->
      <el-table-column type="selection" width="55" />
      <!-- 标签名 -->
      <el-table-column prop="tagName" label="标签名" align="center">
        <template slot-scope="scope">
          <el-tag>
            {{ scope.row.tagName }}
          </el-tag>
        </template>
      </el-table-column>
      <!-- 标签创建时间 -->
      <el-table-column prop="createTime" label="创建时间" align="center" width="200">
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span class="ml4">{{ scope.row.createTime | dateTime }} </span>
        </template>
      </el-table-column>
      <!-- 列操作 -->
      <el-table-column label="操作" align="center" width="160">
        <template slot-scope="scope">
          <el-button v-hasPermi="['article:tag:edit']" size="mini" type="text" icon="el-icon-edit"  @click="openModel(scope.row)">编辑</el-button>
          <el-button v-hasPermi="['article:tag:remove']" size="mini" type="text" icon="el-icon-delete"  @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="queryParams.current"
      :limit.sync="queryParams.size"
      @pagination="getList"
    />
    <!-- 编辑对话框 -->
    <el-dialog :title="tagTitle" :visible.sync="open" width="400px" :close-on-click-modal="false" >
      <el-form ref="tagForm" label-width="80px" :rules="rules" :model="tagForm">
        <el-form-item label="标签名" prop="tagName">
          <el-input  v-model="tagForm.tagName" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="addOrEditTag">
          确 定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getTagsList, addTags, updateTags, removeTags } from "@/api/article/tag";
export default {
  created() {
    this.getList();
  },
  data: function() {
    return {
      loading: true,
      showSearch:true,
      keywords: null,
      open: false,
      tagList: [],
      // 非多个禁用
      multiple: true,
      tagIds: [],
      tagNameList: [],
      tagTitle: "",
      tagForm: {
        tagId: null,
        tagName: ""
      },
      rules: {
        tagName: [
          { required: true, message: "请输入标签名", trigger: "blur" }
        ]
      },
      queryParams: {
        current: 1,
        size: 10,
        tagName: null
      },
      total: 0
    };
  },
  methods: {
    selectionChange(selection) {
      this.tagIds = selection.map(item => item.tagId);
      this.tagNameList = selection.map(item => item.tagName);
      this.multiple = !selection.length;
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.current = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm");
      this.handleQuery();
    },
    handleDelete(row) {
      let ids = this.tagIds;
      let names = this.tagNameList;
      if (row.tagId) {
        ids = [row.tagId];
        names = [row.tagName];
      }
      this.$modal.confirm('是否确认删除标签为"' + names + '"的数据项？').then(function() {
          return removeTags(ids);
        }).then(() => {
          this.getList();
        }).catch(() => {});
    },
    getList() {
      getTagsList(this.queryParams).then(res => {
        this.tagList = res.rows;
        this.total = res.total;
        this.loading = false;
      });
    },
    reset(){
      this.tagForm = {
        tagId: undefined,
        tagName: ""
      }
      this.resetForm('tagForm')

    },
    openModel(tag) {
      this.reset();
      if (tag != null) {
        this.tagForm = JSON.parse(JSON.stringify(tag));
        this.tagTitle = "修改标签";
      } else {
        this.tagTitle = "添加标签";
      }
      this.open = true;
    },
    addOrEditTag() {
      this.$refs.tagForm.validate(valid => {
        if (valid) {
          if(this.tagForm.tagId != null){
            updateTags(this.tagForm).then(res => {
              if (res.flag) {
                this.$modal.msgSuccess("修改成功");
              } else {
                this.$modal.msgError("修改失败");
              }
              this.getList();
              this.open = false;
            });
          }else {
            addTags(this.tagForm).then(res => {
              if (res.flag) {
                this.$modal.msgSuccess("新增成功");
              } else {
                this.$modal.msgError("新增失败");
              }
              this.getList();
              this.open = false;
            });
          }
        }else{
          return false;
        }
      })
    },
    cancel() {
      this.open = false;
      this.reset()
    }
  }
};
</script>
